import { UserCog, UsersRound } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './css/HR.css';

export const hrItems = [
  { 
    path: '/hr/employee-manager', 
    label: 'Menager', 
    icon: UserCog,
    description: 'Zarządzaj pracownikami, działami i stanowiskami',
    requiresPermission: 'hr:manage_employees'
  }
];

const HR = () => {
  const { hasPermission } = useAuth();
  const filteredItems = hrItems.filter(item => {
    if (item.requiresPermission) {
      return hasPermission(item.requiresPermission);
    }
    return true;
  });

  return (
    <div className="page-container">
      <div className="page-header">
        <h2 className="hr-page-title"><UsersRound aria-hidden="true" /> HR</h2>
        <p>Narzędzia HR</p>
      </div>
      
      <div className="page-content">
        <div className="tiles-grid">
          {filteredItems.map((item) => {
            const Icon = item.icon;
            return (
              <Link key={item.path} to={item.path} className="tile-card hr-tile">
                <span className="tile-icon hr-tile-icon" aria-hidden="true"><Icon strokeWidth={1.8} /></span>
                <h3 className="tile-title">{item.label}</h3>
                <p className="tile-description">{item.description}</p>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default HR;
